import { configureStore } from '@reduxjs/toolkit'
import reduxThunk from 'redux-thunk'
import reducer from './reducers'

export default configureStore({
    reducer,
    middleware: [reduxThunk],
})